import { gql } from "@apollo/client"
import { DEPENDENT_ENROLLMENT_FIELDS } from "./DependentEnrollmentFields"

export const DEPENDENT_ENROLLMENTS_ON_PROVISIONED_ENROLLMENT_FRAGMENT = gql`
  ${DEPENDENT_ENROLLMENT_FIELDS}
  fragment DependentEnrollmentsOnProvisionedEnrollmentFragment on BenefitsProvisionedEnrollment {
    dependentEnrollments {
      collection {
        ...DependentEnrollmentFields
      }
    }
  }
`
